import React, { useEffect, useState } from "react";
import ItemCategoriesList from "./item-categories-list/item-categories-list";
import ItemCategoriesAdd from "./item-categories-add/item-categories-add";
import ItemCategoriesEdit from "./item-categories-edit/item-categories-edit";
import ItemCategoriesDelete from "./item-categories-delete/item-categories-delete";
import { checkAuthState } from "../../authentication/auth-utils/auth-utils";
import { useNavigate } from 'react-router-dom';

const ItemCategoriesContainer = () => {
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState(null);

    useEffect(() => {
        checkAuthState((isLoggedIn) => {
          setIsAuthorized(isLoggedIn);
        });
    }, []);

    useEffect(() => {
        if (isAuthorized === false) {
          navigate('/');
        }
    }, [isAuthorized, navigate]);

    return (
        <>
            <div style={{ padding: 20 }}>
                <ItemCategoriesList/>
                <ItemCategoriesAdd/>
                <ItemCategoriesEdit/>
                <ItemCategoriesDelete/>
            </div>
        </>
    )
};

export default ItemCategoriesContainer;